<kl-form-container
  [title]="title"
  [mode]="mode"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow || errorShow"
  [alertType]="alertType"
  (onCloseAlert)="alertShow = false; errorShow = false"
  (onCommitSave)="commitSave($event)"
>
  <form #ShippingAddressForm="ngForm" class="m-2" novalidate>
    <div class="col-md-12">
      <div class="row">
        <div class="col-6">
          <div class="form-group row">
            <label for="shipping_adress_num" class="col-3">
              <small>
                {{ "code" | translate }} <i class="text-danger">*</i></small
              >
            </label>
            <div class="col-md-9 col-sm-6">
              <div class="input-group">
                <input
                  type="text"
                  [disabled]="isReadOnly"
                  id="shipping_adress_num"
                  name="shipping_adress_num"
                  class="form-control form-control-sm"
                  required
                  maxlength="10"
                  #shipping_adress_no="ngModel"
                  [ngClass]="
                    errorShow && shipping_adress_no.invalid ? 'errorInput' : ''
                  "
                  [(ngModel)]="entity.code"
                />
                <div
                  class="input-group-append"
                  (click)="!isReadOnly ? generateCode() : ''"
                >
                  <span
                    class="input-group-text transparent code-icon"
                    id="basic-addon2"
                  >
                    <img src="assets/img/keys.svg" style="width: 20px" />
                  </span>
                </div>
              </div>
              <div
                *ngIf="errorShow && shipping_adress_no.invalid"
                class="errorMessage"
              >
                {{ "important_area" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <label for="shipping_adress_name" class="col-3">
              <small
                >{{ "description" | translate }}
                <i class="text-danger">*</i></small
              >
            </label>
            <div class="col-9">
              <input
                type="text"
                maxlength="50"
                name="shipping_adress_name"
                id="shipping_adress_name"
                #shipping_adress_name="ngModel"
                #focusElement
                [disabled]="isReadOnly"
                [(ngModel)]="entity.description"
                [ngClass]="
                  errorShow && shipping_adress_name.invalid ? 'errorInput' : ''
                "
                class="form-control form-control-sm"
                aria-describedby="shipping_adress_name_help_text"
                required
              />
              <div
                *ngIf="errorShow && shipping_adress_name.invalid"
                class="errorMessage"
              >
                {{ "important_area" | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown-divider"></div>
    <div class="col-md-12">
      <div class="clearfix"></div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group row">
            <label for="shipping_address_country" class="col-md-3 col-sm-6">
              <small>{{ "country" | translate }}</small>
            </label>
            <div class="col-md-9 col-sm-6">
              <p-dropdown
                [emptyFilterMessage]="'not_found' | translate"
                [options]="countryList"
                [(ngModel)]="entity.country"
                [disabled]="changeStatus || isReadOnly"
                dataKey="id"
                name="shipping_address_country"
                id="shipping_address_country"
                (onChange)="onCountryChange($event)"
                optionLabel="description"
                [style]="{ width: '100%' }"
                filter="true"
                placeholder="{{ 'unselected' | translate }}"
              >
              </p-dropdown>
              <a
                class="dropdownInput inputClear"
                [hidden]="!entity.country || isReadOnly || changeStatus"
                (click)="clearCountry()"
              >
                <i class="fal fa-close"></i>
              </a>
            </div>
          </div>
          <div class="form-group row" [hidden]="!regionStatus">
            <label for="shipping_address_region" class="col-md-3 col-sm-6">
              <small>{{ "region" | translate }}</small>
            </label>
            <div class="col-md-9 col-sm-6">
              <p-dropdown
                [emptyFilterMessage]="'not_found' | translate"
                [options]="regionList"
                [(ngModel)]="entity.region"
                [disabled]="countryChange || changeStatus || !regionList.length"
                dataKey="id"
                name="shipping_address_region"
                id="shipping_address_region"
                (onChange)="onRegionChange($event)"
                optionLabel="description"
                [style]="{ width: '100%' }"
                filter="true"
                placeholder="{{ 'unselected' | translate }}"
              >
              </p-dropdown>
              <a
                class="dropdownInput inputClear"
                [hidden]="!entity.region || isReadOnly || changeStatus"
                (click)="clearRegion()"
              >
                <i class="fal fa-close"></i>
              </a>
              <kl-indicator [show]="countryChange"></kl-indicator>
            </div>
          </div>
          <div class="form-group row" id="state" [hidden]="!stateStatus">
            <label for="shipping_address_state" class="col-md-3 col-sm-6">
              <small>{{ "state" | translate }}</small>
            </label>
            <div class="col-md-9 col-sm-6">
              <p-dropdown
                [emptyFilterMessage]="'not_found' | translate"
                [options]="stateList"
                [(ngModel)]="entity.state"
                dataKey="id"
                name="shipping_address_state"
                id="shipping_address_state"
                [disabled]="
                  countryChange ||
                  regionChange ||
                  changeStatus ||
                  !stateList.length
                "
                (onChange)="onStateChange($event)"
                optionLabel="description"
                [style]="{ width: '100%' }"
                filter="true"
                placeholder="{{ 'unselected' | translate }}"
              >
              </p-dropdown>
              <a
                class="dropdownInput inputClear"
                [hidden]="!entity.state || isReadOnly || changeStatus"
                (click)="clearState()"
              >
                <i class="fal fa-close"></i>
              </a>
              <kl-indicator
                [show]="countryChange || regionChange"
              ></kl-indicator>
            </div>
          </div>
          <div class="form-group row">
            <label for="shipping_address_city" class="col-md-3 col-sm-6">
              <small>{{ "city" | translate }}</small>
            </label>
            <div class="col-md-9 col-sm-6 position-relative">
              <p-dropdown
                [emptyFilterMessage]="'not_found' | translate"
                [options]="cityList"
                [(ngModel)]="entity.city"
                dataKey="id"
                name="shipping_address_city"
                [disabled]="
                  !cityList.length ||
                  stateChange ||
                  regionChange ||
                  changeStatus
                "
                id="shipping_address_city"
                (onChange)="onCityChange($event)"
                optionLabel="description"
                [style]="{ width: '100%' }"
                filter="true"
                placeholder="{{ 'unselected' | translate }}"
              >
              </p-dropdown>
              <a
                class="dropdownInput inputClear"
                [hidden]="!entity.city || isReadOnly || changeStatus"
                (click)="clearCity()"
              >
                <i class="fal fa-close"></i>
              </a>
              <kl-indicator [show]="stateChange || regionChange"></kl-indicator>
            </div>
          </div>
          <div class="form-group row">
            <label for="shipping_address_county" class="col-md-3 col-sm-6">
              <small>{{ "county" | translate }}</small>
            </label>
            <div class="col-md-9 col-sm-6">
              <p-dropdown
                [emptyFilterMessage]="'not_found' | translate"
                [options]="countyList"
                [(ngModel)]="entity.county"
                [disabled]="!countyList.length || cityChange || changeStatus"
                dataKey="id"
                name="shipping_address_county"
                id="shipping_address_county"
                optionLabel="description"
                [style]="{ width: '100%' }"
                filter="true"
                placeholder="{{ 'unselected' | translate }}"
              >
              </p-dropdown>
              <a
                class="dropdownInput inputClear"
                [hidden]="!entity.county || isReadOnly || changeStatus"
                (click)="entity.county = null"
              >
                <i class="fal fa-close"></i>
              </a>
              <kl-indicator [show]="cityChange"></kl-indicator>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group row">
            <label for="shipping_adress_phone_no_1" class="col-3">
              <small>{{ "phone" | translate }}</small>
            </label>
            <div class="col-9">
              <input
                type="text"
                [disabled]="isReadOnly"
                maxlength="15"
                name="shipping_adress_phone_no_1"
                id="shipping_adress_phone_no_1"
                class="form-control form-control-sm"
                aria-describedby="shipping_adress_phone_no_1_help_text"
                [(ngModel)]="entity.phone"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for="shipping_adress_phone_no_2" class="col-3">
              <small>{{ "phone" | translate }} 2</small>
            </label>
            <div class="col-9">
              <input
                type="text"
                [disabled]="isReadOnly"
                maxlength="15"
                name="shipping_adress_phone_no_2"
                id="shipping_adress_phone_no_2"
                class="form-control form-control-sm"
                aria-describedby="shipping_adress_phone_no_2_help_text"
                [(ngModel)]="entity.phone2"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for="shipping_adress_fax_num" class="col-3">
              <small>{{ "fax_num" | translate }}</small>
            </label>
            <div class="col-9">
              <input
                type="text"
                [disabled]="isReadOnly"
                name="shipping_adress_fax_num"
                maxlength="15"
                id="shipping_adress_fax_num"
                class="form-control form-control-sm"
                aria-describedby="shipping_adress_fax_no_help_text"
                [(ngModel)]="entity.fax_num"
              />
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group row">
            <label
              for="shipping_adress_address"
              class="col-md-2"
              style="max-width: 12.66666667% !important"
            >
              <small>{{ "address" | translate }}</small>
            </label>
            <div
              class="col-md-10"
              style="
                flex: 0 0 87.333333% !important;
                max-width: 87.333333% !important;
              "
            >
              <textarea
                name="shipping_adress_address"
                [disabled]="isReadOnly"
                id="shipping_adress_address"
                maxlength="100"
                class="form-control"
                cols="30"
                rows="2"
                [(ngModel)]="entity.address"
                style="resize: none"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</kl-form-container>
